export function popupURL() {
  const button = document.querySelectorAll('.js-popup-url');
  if(button.length) {
    for (let i = 0; i < button.length; i++) {
      const el = button[i];
      el.addEventListener('click', function(e) {
        e.preventDefault();
        const url = el.getAttribute('href');
        const popup = window.open(url,"","width=600,height=400,scrollbars=yes,status=no,toolbar=no,location=no,menubar=no,directories=no,resizable=yes");
        popup.focus();
      });
    }
  }
}